import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Permissions } from '../models/staff.model';
import { SelectItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends ServiceBase {
  public api = '/GalleryStaffPermission';

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getAllPermissions(): Observable<SelectItem[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SelectItem[]>(url, httpOptions);
  }

  public getAllPermissionByStaffId(GalleryStaffId: string): Observable<Permissions[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetchByStaffId/';
    const url: string = environment.BASE_API_PATH + this.api + method + GalleryStaffId;
    console.log("url", url)
    return this.http.get<Permissions[]>(url, httpOptions);
  }

  public savePermissions(GalleryStaffId: string, selectedPermissionIds: string[]): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/save/';
    const url: string = environment.BASE_API_PATH + this.api + method + GalleryStaffId;
    return this.http.post<ResponseObject>(url, selectedPermissionIds, httpOptions);
  }
}
